module.exports = __webpack_public_path__ + "img/Property 1=4x3, Property 2=BV - Bouvet Island.3f88db16.svg";